export const getLanguageOptions = (l) =>
  l?.map((item) => ({ label: item.name, value: item.iso })) || [];

export const getSingleValueWithLanguage = (l, lang) =>
  l?.find((item) => item.language === lang) || '';

export const getArrayValueWithLanguage = (l, lang) => l.filter((item) => item.language === lang);
